export const createHandleChange = (setValidationErrors) => {
  return (field) => {
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [field]: undefined
    }));
  };
};
